import { Reveal } from "@/components/Reveal";
import { MARQUEE_ITEMS } from "@/data/site";

function MarqueeRow() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="ts-marquee relative flex w-full overflow-hidden border-y border-white/10 bg-black py-5">
      <div className="ts-marquee-track">
        {items.map((item, i) => (
          <span key={i} className="mx-6 inline-flex items-center gap-6">
            <span className="font-display text-xl font-bold tracking-tight text-neutral-100">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-brand" />
          </span>
        ))}
      </div>
    </div>
  );
}

export default function About() {
  return (
    <section id="about" className="bg-black py-24 sm:py-28">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.2fr] lg:gap-20">
          <Reveal>
            <p className="font-display text-xs font-semibold uppercase tracking-[0.3em] text-brand">
              About Tech Siksha
            </p>
            <div className="mt-5 h-px w-16 bg-gradient-to-r from-brand to-cyan-accent" />
          </Reveal>
          <div>
            <Reveal>
              <h2 className="font-display text-3xl font-black leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl">
                A technology education & digital learning platform built for the
                real world.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-7 text-lg leading-relaxed text-neutral-400">
                Tech Siksha helps you learn technology the practical way. We
                cover AI tools, website development, mobile apps, Android and
                iPhone tips, PC tips, productivity, automation and the latest
                technology — all distilled into clear, actionable guides.
              </p>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="mt-5 text-base leading-relaxed text-neutral-400">
                Whether you're a creator, student, or business owner, our mission
                is to help you build modern digital skills and stay ahead of a
                fast-moving tech landscape.
              </p>
            </Reveal>
          </div>
        </div>
      </div>

      <div className="mt-20">
        <MarqueeRow />
      </div>
    </section>
  );
}
